import {renderRoutes} from "react-router-config";
import React from "react";

export function PageContent({route}: any) {

    return (
        <div className={'page-content'}>
            {!!route && renderRoutes(route.routes)}
        </div>
    )
}
